import { inputCls } from "../lib/ui";

export const AuthForm = ({ mode, form, setForm, error, loading, submitLabel, onSubmit }) => (
  <form onSubmit={onSubmit} className="mt-12 space-y-6">
    {mode === "register" && (
      <input
        data-testid="auth-name-input"
        className={inputCls}
        placeholder="Your full name"
        value={form.name}
        onChange={(e) => setForm({ ...form, name: e.target.value })}
        required
      />
    )}
    <input
      data-testid="auth-email-input"
      className={inputCls}
      type="email"
      placeholder="Email address"
      value={form.email}
      onChange={(e) => setForm({ ...form, email: e.target.value })}
      required
    />
    <input
      data-testid="auth-password-input"
      className={inputCls}
      type="password"
      placeholder="Password (min 6 characters)"
      value={form.password}
      onChange={(e) => setForm({ ...form, password: e.target.value })}
      required
    />
    {error && (
      <p data-testid="auth-error-message" className="text-sm text-[#9A3B3B]">
        {error}
      </p>
    )}
    <button
      data-testid="auth-submit-button"
      type="submit"
      disabled={loading}
      className="w-full bg-[#7A3B3F] text-[#FAF9F6] px-8 py-4 hover:bg-[#5D2B2E] transition-colors duration-300 disabled:opacity-60"
    >
      {submitLabel}
    </button>
  </form>
);
